import { action, observable } from "mobx";
import { Moment } from "moment";
import { createContext, useContext } from "react";

export class TermsAndConditionsState {
  @observable
  onboardAt!: Moment;

  @observable
  agreementDate!: Moment;

  @observable
  agreeToTnC = false;

  @action
  toggleAgreeToTnC = () => {
    this.agreeToTnC = !this.agreeToTnC;
  };

  toJSON = () => {
    return {
      /**
       * Passport BI Audit Fix
       * PTEN
       */
      // aspi: {
      //   onboarding_status: "ready_to_onboard",
      // },
      applications: {
        midtrans: {
          onboard_at: this.onboardAt?.toISOString(),
          agreement_date: this.agreementDate?.toISOString(),
        },
      },
    };
  };
}

const TermsAndConditionsContext = createContext(new TermsAndConditionsState());

export const useTermsAndConditionsState = () =>
  useContext(TermsAndConditionsContext);
